import React, { Component } from "react"

import Header from '../../components/Header/Header';
import Content_Mapa from "./Content_Mapa";
import Footer from '../../components/Footer/Footer';

class Mapa extends Component {
    render() {
        return (

            <div class="main-container">
                <Header />
                <Content_Mapa />
                <Footer />
            </div>

        )
    }
}

export default Mapa;